module.exports = __webpack_public_path__ + "img/home3.a12bac43.jpg";